import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';

import 'pages/ws/assets/styles/ws-report.scss';
import { formatNumberToCurrency, formatRateToPercent, getAcquiredListCount } from 'utils/app';

import type { JSX } from 'react';

/**
 * ホーム画面 利用状況コンポーネント
 */
export default function WsIndexUsage(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useAtom(AcctState);

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-statistical">
        <div className="container">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-5 row-report-statistical-metrics row-15-xl row-5-xl row-12-lg">
            <div>
              <div className="card card-white">
                <div className="card-body">
                  <div className="d-flex d-flex-statistical">
                    <div className="flex-shrink-0 flex-left">
                      <small>参加数</small>
                      {formatNumberToCurrency(acctState.usage.report.total.participatedCount)}
                    </div>
                    <div className="flex-grow-1 flex-right">
                      <span className="img-body light-blue">
                        <img src="/img/icon/people.svg" alt="参加数" className="w-lg-26" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="card card-white">
                <div className="card-body">
                  <div className="d-flex d-flex-statistical">
                    <div className="flex-shrink-0 flex-left">
                      <small>獲得リスト数</small>
                      {formatNumberToCurrency(
                        getAcquiredListCount(
                          acctState.usage.report.total.mailAddressCount,
                          acctState.usage.report.total.lineCount
                        )
                      )}
                    </div>
                    <div className="flex-grow-1 flex-right">
                      <span className="img-body light-yellow">
                        <img
                          src="/img/icon/arrow.svg"
                          alt="獲得リスト数 10293"
                          className="w-lg-26"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="card card-white">
                <div className="card-body">
                  <div className="d-flex d-flex-statistical">
                    <div className="flex-shrink-0 flex-left">
                      <small>リスト獲得率</small>
                      {`${formatRateToPercent(
                        getAcquiredListCount(
                          acctState.usage.report.total.mailAddressCount,
                          acctState.usage.report.total.lineCount
                        ),
                        acctState.usage.report.total.participatedCount
                      )}%`}
                    </div>
                    <div className="flex-grow-1 flex-right">
                      <span className="img-body light-green">
                        <img src="/img/icon/chart.svg" alt="リスト獲得率 20%" className="w-lg-23" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="card card-white">
                <div className="card-body">
                  <div className="d-flex d-flex-statistical">
                    <div className="flex-shrink-0 flex-left">
                      <small>完了数</small>
                      {formatNumberToCurrency(acctState.usage.report.total.answeredCount)}
                    </div>
                    <div className="flex-grow-1 flex-right">
                      <span className="img-body light-violet">
                        <img src="/img/icon/tick.svg" alt="完了数" className="w-lg-23" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="card card-white">
                <div className="card-body">
                  <div className="d-flex d-flex-statistical">
                    <div className="flex-shrink-0 flex-left">
                      <small>完了率</small>
                      {`${formatRateToPercent(
                        acctState.usage.report.total.answeredCount,
                        acctState.usage.report.total.participatedCount
                      )}%`}
                    </div>
                    <div className="flex-grow-1 flex-right">
                      <span className="img-body light-pink">
                        <img src="/img/icon/oclock.svg" alt="完了率 80%" className="w-lg-23" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
